import type { RequestConfig } from '@@/plugin-request/request';
import { errorConfig } from './requestErrorConfig';
// import { queryLogin, queryWeChatSetting } from '@/service';
// import md5 from 'js-md5';
// import qs from 'qs';
// import wx from 'weixin-js-sdk';
import { history } from '@umijs/max';
import VConsole from 'vconsole';
// import { config } from '@/utils/config';
import { ToLogin } from '@/service/login';
// eslint-disable-next-line @typescript-eslint/no-unused-expressions
// process.env.NODE_ENV === 'development' &&
new VConsole();

export async function getInitialState(): Promise<any> {
 
  // console.log(window.localStorage.getItem('loginInfo'));
  // if (window.localStorage.getItem('loginInfo')) {
  //   const data = window.localStorage.getItem('loginInfo')
  //     ? JSON.parse(localStorage.getItem('loginInfo') || '')
  //     : '';
  //   ToLogin({ ...data, source: 'owner' }).then((res: any) => {
  //     if (res && res.code === 200) {
  //       // Toast.success('登录成功！');

  //       window.localStorage.setItem('token', res.token);
  //       // window.localStorage.setItem('userInfo', JSON.stringify(values),)
  //       history.push('/');
  //     } else {
  //       history.push('/login');
  //     }
  //   });
  // } else {
  //   history.push('/login');
  // }
}

export const request: RequestConfig = {
  ...errorConfig,
};

export const reactQuery = {
  // devtool: process.env.NODE_ENV === 'development',
  queryClient: true,
};
